import { useMemo } from 'react'
import { marked } from 'marked'
import DOMPurify from 'dompurify'
import { useTranslation } from 'react-i18next'

import { useTheme } from '../hooks/useTheme'
import MenuBar from '../components/MenuBar/MenuBar'
import { getPrivacyContent } from '../privacy/index'
import styles from './PrivacyPage.module.css'

/**
 * Standalone public page at /privacy.
 *
 * Content is rendered from GFM Markdown so that it can be authored per
 * language in plain text files under src/privacy/.  The active interface
 * language (from i18next) determines which translation is shown; English is
 * the fallback.
 *
 * useTheme() is called here so that html[data-theme] is applied even when the
 * user navigates directly to /privacy without going through NewspaperLayout.
 */
export default function PrivacyPage() {
  useTheme()
  const { t, i18n } = useTranslation()

  const contentHtml = useMemo(() => {
    const md = getPrivacyContent(i18n.language)
    return DOMPurify.sanitize(marked.parse(md) as string)
  }, [i18n.language])

  return (
    <div className={styles.pageWrapper}>
      <MenuBar lang="" city="" />
      <main className={styles.main}>
        <div className="staticPage">
          <h1 className="staticPageTitle">{t('privacy_notice')}</h1>
          <div
            className={styles.privacyContent}
            dangerouslySetInnerHTML={{ __html: contentHtml }}
          />
        </div>
      </main>
    </div>
  )
}
